import auth from '../../middleware/auth'
import can from '../../middleware/can'

export default [
  {
    path: '/beverages',
    name: 'Beverages',
    component: () =>
      import(
        /* webpackChunkName: "beverages" */ '@/pages/beverages/BeverageIndex'
      ),
    meta: {
      middleware: [auth, can('isBeveragesShow')],
      title: 'beverages',
      breadCrumb: [{ text: 'beverages' }]
    }
  },
  {
    path: '/beverage/:beverageId',
    name: 'BeverageShow',
    component: () =>
      import(
        /* webpackChunkName: "beverageShow" */ '@/pages/beverages/BeverageShow'
      ),
    props: true,
    meta: {
      middleware: [auth, can('isBeveragesShow')],
      title: 'beverages',
      breadCrumb: [
        { text: 'beverages', to: { name: 'Beverages' } },
        { text: undefined }
      ]
    }
  }
]
